export default __webpack_public_path__ + "static/14_34-1477879f7c1b518f7aea14a23f1724fd.png";